<template>
  <div class="registration">
    <inline-svg @click="goBack" :src="require('../../assets/svg/x.svg').default"></inline-svg>
    <h2>
      {{ $t("registration.registration.text1") }}
      <inline-svg
        class="lockbreak"
        :src="require('../../assets/svg/lockbreak.svg').default"
      ></inline-svg>
    </h2>
    <div v-if="isLoading" v-html="htmlModal" class="modal-container"></div>
    <div class="register-text" v-if="!user">
      {{ $t("registration.registration.text1") }}
    </div>
    <div v-if="!user">
      <GoogleButton />
    </div>
    <div v-if="user" class="program-choose">
      <p class="subtitle">{{ $t("registration.registration.text3") }}</p>
      <div v-if="!payment_options.length">
        {{ $t("registration.registration.loading") }}
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-for="(option, idx) in payment_options" :key="idx" class="program-option" :class="{
        chosenOption: chosenPayment == idx + 1,
        bestOption: option.recommended
      }" @click="chosenPayment = idx + 1">
        <div v-if="option.recommended" class="recomanded" v-bind:class="ltr ? 'recommended-left' : 'recommended-right'">{{  $t("registration.registration.recommended") }}</div>
        <span>{{ option.text }}</span>
        <div class="prices">
          <span>
            {{ $t("registration.registration.sum") }} ₪{{
              Math.round(option.price) * (option.recurring || 1)
            }}</span
          >
          <span class="monthp"
            >₪{{
              (Math.round(option.price) / (option.months || 1)).toFixed(1)
            }}
            {{ $t("registration.registration.month") }}</span
          >
        </div>
      </div>
    </div>
    <br />
    <div v-if="user" class="submit-payment">
      <button @click="goPay">
        {{ $t("registration.registration.payment") }}
      </button>
      <div class="disclaimer-text">
        {{ $t("registration.registration.disclaimer.part_1") }} <strong>{{ $t("registration.registration.disclaimer.part_2") }}</strong>. {{ $t("registration.registration.disclaimer.part_3") }}-{{new Date().toLocaleDateString('he-il')}} {{ $t("registration.registration.disclaimer.part_4") }} {{getSelectedPlanCycle()}}. {{ $t("registration.registration.disclaimer.part_5") }}.
      </div>
    </div>
    <br />
    <div class="footerLinks">
      <span @click="goToWA">{{ $t("registration.registration.text4") }}</span>
      <span @click="navigate('privacy')">{{
        $t("registration.registration.text5")
      }}</span>
      <span @click="navigate('terms')">{{
        $t("registration.registration.text6")
      }}</span>
    </div>
    <div v-if="user" style="text-align: center;">
      <img src="../../assets/img/payment_logos.svg" />
    </div>
  </div>
</template>

<script>
import VideoPlayer from "@/components/Shared/VideoPlayer.vue";
import GoogleButton from "../User/googleButton.vue";
import "./registration.scss";

export default {
  data() {
    return {
      chosenPayment: 1,
      htmlModal: "",
      isLoading: false,
      ltr: localStorage.getItem("srcDirection") == "ltr",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    payment_options() {
      return this.$store.getters.payment_options;
    }
  },
  watch: {
    payment_options() {
      if (this.payment_options.length) this.chosenPayment = payment_options.find(option.recommended) || 1;
    }
  },
  mounted() {
    if (this.payment_options.length) this.chosenPayment = 1;
  },
  methods: {
    getSelectedPlanCycle(){
      const selectedPlanCycle = this.payment_options[this.chosenPayment - 1].months
      return  this.$t(`registration.registration.months.${selectedPlanCycle}`)
    },
    goPay() {
      if (this.chosenPayment) {
        this.$router.push({
          path: `/payment/${this.payment_options[this.chosenPayment - 1].id}`
        });
      }
    },
    goBack() {
      this.$router.push('/');
    },
    navigate(path) {
      this.$router.push(`/${path}`);
    },
    goToWA() {
      //console.log("YO");
      window.open(
        "https://api.whatsapp.com/send?phone=972526252650&text=%D7%94%D7%99%D7%99!%20%F0%9F%98%83%0A%D7%90%D7%A0%D7%99%20%D7%A8%D7%9B%D7%A9%D7%AA%D7%99%20%D7%9E%D7%A0%D7%95%D7%99%20%D7%9C%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%94%20%D7%A9%D7%9C%D7%9A%20%D7%9B%D7%91%D7%A8%20%D7%95%D7%92%D7%9D%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A7%D7%91%D7%9C%D7%94%20%D7%90%D7%91%D7%9C%20%D7%96%D7%94%20%D7%93%D7%95%D7%A8%D7%A9%20%D7%9E%D7%9E%D7%A0%D7%99%20%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%AA%D7%95%D7%9B%D7%9C%20%D7%9C%D7%A2%D7%96%D7%95%D7%A8%20%D7%9C%D7%99%20%D7%9C%D7%A9%D7%97%D7%96%D7%A8%20%D7%90%D7%AA%20%D7%94%D7%9E%D7%A0%D7%95%D7%99%20%D7%A9%D7%9C%D7%99%3F%0A%D7%AA%D7%95%D7%93%D7%94",
        "_blank"
      );
    }
  },
  components: {
    VideoPlayer,
    GoogleButton
  }
};
</script>

<style scoped>
.monthp {
  font-size: 12px;
  font-weight: 400;
}

.prices {
  display: flex;
  flex-direction: column;
}

.footerLinks {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  margin-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// registration.vue?b966bf00